// Mapping business type -> recommended ambiance IDs
export const BUSINESS_PLAYLISTS = {
  cafe: ['morning-coffee', 'modern-days', 'zen-wellness'],
  restaurant: [
    'soir-elegance',
    'morning-coffee',
    'cocktail-time',
    'zen-wellness',
  ],
  bar: ['cocktail-time', 'soir-elegance', 'movement', 'modern-days'],
  salon: ['modern-days', 'morning-coffee', 'zen-wellness'],
  boutique: ['modern-days', 'morning-coffee', 'cocktail-time'],
  spa: ['zen-wellness', 'morning-coffee', 'soir-elegance'],
  gym: ['movement', 'cocktail-time'],
  hotel: ['soir-elegance', 'morning-coffee', 'modern-days', 'zen-wellness'],
};
